import { getLocalDataIfNotExpired } from '@services/storage';

import { FaiType } from '@app-types/plan';

import { ELIGIBILITY_STORAGE_KEY, TECHNOLOGY } from '@constants/provider';

import { SavedEligibilityResultType } from '@eligibility/helpers';

export interface SpeedInfos {
    upRates: string;
    downRates: string;
    speedWording?: string;
}

export function getSpeedInfos(plan: FaiType): SpeedInfos {
    const speedInfos: SpeedInfos = {
        upRates: plan.upRates,
        downRates: plan.downRates,
        speedWording: plan.speedWording,
    };

    const eligibilityResult = getLocalDataIfNotExpired<SavedEligibilityResultType>(ELIGIBILITY_STORAGE_KEY.RESULTS);

    if (plan?.technology && [TECHNOLOGY.BOX_5G].includes(plan.technology)) {
        speedInfos.upRates = '58\u00A0Mb/s';
        speedInfos.downRates = '1,1\u00A0Gb/s';

        return speedInfos;
    }

    const planFromEligibilityResult = eligibilityResult?.offers?.find(
        (offer) =>
            offer.rangeNg === plan?.rangeNg &&
            offer.commercialSeries === plan?.commercialSeries &&
            offer.technology === plan?.technology,
    );

    if (planFromEligibilityResult && planFromEligibilityResult.speed_up && planFromEligibilityResult.speed_down) {
        speedInfos.upRates = planFromEligibilityResult.speed_up;
        speedInfos.downRates = planFromEligibilityResult.speed_down;
        speedInfos.speedWording = undefined;
    }

    return speedInfos;
}
